import { createContext } from 'react';
import { DamageEditFormContextProps } from './damage-edit-form.props';
import { UseFormReturn } from 'react-hook-form';

export const DamageEditFormContext = createContext<DamageEditFormContextProps>({
  reactHookForm: {} as UseFormReturn,
  formFields: []
});
